import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-vestra-user-search',
    templateUrl: './vestra-user-search.component.html',
    styleUrl: './vestra-user-search.component.scss',
})
export class VestraUserSearchComponent {
    @Output()
    searchProperties: EventEmitter<{ propertyName: string; propertyValue: string }> = new EventEmitter();

    public form: FormGroup = this.getFormGroup();

    constructor() {}

    private getFormGroup(): FormGroup {
        return new FormGroup({
            propertyName: new FormControl(''),
            propertyValue: new FormControl(''),
        });
    }

    public onSearch() {
        if (this.form.valid) {
            this.searchProperties.emit(this.form.value);
        }
    }

    public onClear() {
        this.form.reset({
            propertyName: '',
            propertyValue: '',
            isProviderReferral: false,
        });

        this.searchProperties.emit({ propertyName: null, propertyValue: null });
    }
}
